import { createApp,h } from 'vue';
const app = createApp(App);
import App from './App.vue';
import {createI18n, I18n} from 'vue-i18n'
import {lang_tid} from './lib/i18n'
import {getLang} from "./lib/utils.ts";
import 'element-plus/dist/index.css'
//i18n
let lang = getLang();
console.log("lang:",lang)
const i18n:I18n = createI18n({
    legacy: false,
    locale: lang,
    messages:lang_tid,
})

app.use(i18n)
app.mount('#app')
